import { ReactElement } from 'react';
import CustomTooltip from '../reusable/CustomTooltip';
import InsufficientData from './InsufficientData';
import useCategoryUploadState from '../hooks/useCategoryUploadState';

import './CardContainer.css';

interface CardContainerProps {
  title: string;
  tooltipTitle?: string | ReactElement<any, any> | undefined;
  centerTitle?: boolean;
  children: React.ReactNode;
  classes?: Array<string>;
  button?: React.ReactNode;
  customHeader?: React.ReactNode;
  noTitle?: boolean;
  icon?: string | null;
  categoryDataLabel?: string;
  categoryId?: string;
}

function CardContainer({
  title,
  tooltipTitle,
  children,
  classes,
  button,
  customHeader,
  centerTitle = false,
  noTitle = false,
  icon,
  categoryDataLabel,
  categoryId,
}: CardContainerProps) {
  const classNames = classes ? classes.join(' ') : '';
  const hasSufficientData = useCategoryUploadState(categoryDataLabel || '');

  return (
    <div className={`card-container ${classNames}`} data-testid="card-container">
      {noTitle ? null : (
        <div className={`card-container-header ${centerTitle ? 'centered' : ''}`} data-testid="card-container-header">
          {customHeader ? (
            customHeader
          ) : (
            <>
              <div className="card-container-title">
                <p>{title}</p>
                {icon ? (
                  <CustomTooltip title={tooltipTitle} placement="top" arrow={true}>
                    <img src={icon} alt="info icon" />
                  </CustomTooltip>
                ) : null}
              </div>
            </>
          )}
          {button && hasSufficientData ? button : null}
        </div>
      )}
      {hasSufficientData ? (
        <div className="card-container-content" data-testid="card-container-content">
          {children}
        </div>
      ) : (
        <InsufficientData category={categoryDataLabel || ''} categoryId={categoryId || ''} />
      )}
    </div>
  );
}

export default CardContainer;
